var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCompanyDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8534_12060)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#041A72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.984 18L24.7016 29.8862L25.8034 31.6847L30.4053 29.8845C30.3331 29.6874 30.2961 29.478 30.2961 29.267C30.2961 28.2988 31.0519 27.5139 31.984 27.5139C32.9162 27.5139 33.672 28.2988 33.672 29.267C33.672 30.2351 32.9162 31.0201 31.984 31.0201C31.5037 31.0201 31.0469 30.8073 30.7261 30.4357L16 44.1134C25.8 37.7865 38.2117 37.7987 48 44.1448L31.984 18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8534_12060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCompanyDefault);
export default __webpack_public_path__ + "static/media/logo-company-default.9e7c8bfd44287e43049d9d9ca7c2dfc6.svg";
export { ForwardRef as ReactComponent };